<template>
    <v-card>
        <v-card-title class="text-h5">API</v-card-title>
        <v-card-subtitle>
            Ссылка на документацию <a class="d-flex justify-end" target="_blank" href="https://debts-api.ais24.ru/docs/api/v1">https://debts-api.ais24.ru/docs/api/v1</a>
        </v-card-subtitle>
        <v-card-text>
            <v-row justify="center">
                <v-col lg=8 sm=8 md=8 cols=12>
                    <debt-web-hooks-form></debt-web-hooks-form>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions></v-card-actions>
    </v-card>
</template>

<script>
import DebtWebHooksForm from "../components/user/DebtWebHooksForm.vue";

export default {
    name: 'ApiPage',
    components:{
        DebtWebHooksForm
    },
    data(){
        return {
        }
    },
    methods: {

    },
    computed: {
    }
}
</script>